import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'
import { theme, Theme, themeUtils } from 'styles/theme'

interface VoteCardContainerProps {
  theme: Theme
  transparent?: boolean
}

export const VoteCardContainer = styled.div<VoteCardContainerProps>`
  ${themeUtils.button}
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 91;
  padding: 10px 35px;

  ${media.maxWidth.sm} {
    margin-top: 20px;
    border-radius: 20px;
    background-color: ${unifiedColors.surface.subdued};
    border: 1px solid ${theme.palette.surface.tertiary};
    ${({ transparent, theme }) =>
      transparent &&
      css`
        background: transparent;
        border: none;
        a {
          color: ${theme.palette.label.default};
        }
      `}
  }
`

export const BadgeContainer = styled.div`
  margin: 0px auto 18px auto;
`

export const HowItWorksLink = styled.a`
  text-decoration: underline;
  &,
  &:hover {
    color: #525252;
  }
  ${themeUtils.minWidth.md} {
    &,
    &:hover {
      color: ${theme.palette.label.default};
    }
  }
  text-align: center;
  padding: 20px;
  font-size: 0.9rem;
  font-weight: 500;
`

export const ModalContent = styled.div`
  max-width: 600px;
  min-width: 300px;
  margin: 12px;
  text-align: center;
`

export const ModalHeading = styled.p`
  font-weight: 700;
  font-size: 1.3rem;
  text-align: center;
`

export const ModalText = styled.p`
  padding: 30px 12px;
  text-align: left;
  width: 100%;
  margin: auto;
`

export const InputWrapper = styled.div`
  display: flex;
  max-width: 400px;
  margin: auto;
`

export const EmailInput = styled.input`
  border: 1px solid ${theme.palette.surface.secondary};
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  width: 100%;
  padding: 0 16px;
`

export const CheckboxContainer = styled.div`
  text-align: left;
  max-width: 450px;
  padding-top: 25px;
`

export const ConditionsLink = styled.p`
  font-size: 0.8rem;
  text-decoration: underline;
  text-align: center;
`
